module.exports = __webpack_public_path__ + "img/a3.fe67e4ad.png";